import { INDUSTRIES } from "./HeroMock.jsx";

export function Dock({ activeIndustry, onChangeIndustry }) {
  const { useState, useEffect } = React;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("top");
    if (!hero) return;
    const onScroll = () => setVisible(window.scrollY > hero.offsetHeight - 120);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div className={`dock${visible ? " dock-visible" : ""}`}>
      <span className="dock-label">Built around</span>
      <div className="dock-tabs">
        {INDUSTRIES.map((ind, i) => (
          <button
            key={ind.key}
            className={`dock-tab${i === activeIndustry ? " dock-tab-active" : ""}`}
            onClick={() => onChangeIndustry(i)}
          >
            {ind.label}
          </button>
        ))}
      </div>
    </div>
  );
}
